// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".io-lazy-background{position:relative;overflow:hidden}.io-lazy-background>div{position:absolute;top:0;left:0;height:100%;width:100%;transform-origin:center;transition:transform .7s ease-in-out}", ""]);
// Exports
module.exports = exports;
